import { useMutation } from "@apollo/client";

import {
  CREATE_OWN_OEM_REPORT_MUTATION,
  CREATE_OWN_OEM_DUPLICATE_REPORT_MUTATION,
  DELETE_REPORT_MUTATION,
  UPDATE_REPORT_MUTATION,
} from "~/api";
import { errorsHandler } from "~/transformers";

export const useCreateReport = () => {
  const [createOwnOemReport, { error = {}, loading }] = useMutation(
    CREATE_OWN_OEM_REPORT_MUTATION,
  );
  return {
    create: (input) =>
      new Promise((resolve, reject) => {
        return createOwnOemReport({
          variables: {
            input,
          },
          update(cache) {
            cache.evict({
              id: "ROOT_QUERY",
              fieldName: "listAllOwnOemReports",
            });
            cache.gc();
          },
        })
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(errorsHandler(err));
          });
      }),
    loading,
    error,
  };
};

export const useCreateDublicateReport = () => {
  const [duplicateOwnOemReport, { error = {}, loading }] = useMutation(
    CREATE_OWN_OEM_DUPLICATE_REPORT_MUTATION,
  );
  return {
    duplicate: (input) =>
      new Promise((resolve, reject) => {
        return duplicateOwnOemReport({
          variables: {
            input,
          },
          update(cache) {
            cache.evict({
              id: "ROOT_QUERY",
              fieldName: "listAllOwnOemReports",
            });
            cache.gc();
          },
        })
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(errorsHandler(err));
          });
      }),
    loading,
    error,
  };
};

export const useUpdateReport = () => {
  const [updateOwnOemReport, { error = {}, loading }] = useMutation(
    UPDATE_REPORT_MUTATION,
  );
  return {
    update: (input) =>
      new Promise((resolve, reject) => {
        return updateOwnOemReport({
          variables: { input },
          update(cache) {
            cache.evict({
              id: "ROOT_QUERY",
              fieldName: "listAllOwnOemReports",
            });
            cache.evict({
              id: "ROOT_QUERY",
              fieldName: "getOwnOemAnalytics",
              args: {
                input: {
                  _id: input._id,
                  withInputTableOptions: true,
                },
              },
            });
            cache.gc();
          },
        })
          .then((data) => {
            resolve(data);
          })
          .catch((err) => {
            reject(errorsHandler(err));
          });
      }),
    loading,
    error,
  };
};

export const useDeleteReport = () => {
  const [remove, { loading, error }] = useMutation(DELETE_REPORT_MUTATION);

  return {
    loading,
    error,
    removeReport: async (id) =>
      new Promise((resolve, reject) =>
        remove({
          variables: {
            id,
          },
          skip: !id,
          update(cache) {
            cache.evict({
              id: "ROOT_QUERY",
              fieldName: "listAllOwnOemReports",
            });
            cache.gc();
          },
        })
          .then((data) => {
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          }),
      ),
  };
};
